{
  "cms.catalogRow.action.discardStagedEdit": "Hylkää sisältömuutokset",
  "cms.discardStagedEdit.confirm.title": "Hylkää sisältömuutokset?",
  "cms.discardStagedEdit.confirm.body": "Julkaisemattomat sisältömuutokset poistetaan pysyvästi. Julkaistu sisältö säilyy sellaisenaan.",
  "cms.discardStagedEdit.confirm.confirm": "Hylkää sisältömuutokset",
  "cms.discardStagedEdit.confirm.cancel": "Peruuta",
  "cms.discardStagedEdit.success": "Sisältömuutokset hylätty.",
  "cms.discardStagedEdit.error": "Sisältömuutosten hylkääminen epäonnistui. Yritä uudelleen."
}
